// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"143":"f09c7d68","212":"195cdcce","370":"f09c7d68","397":"f09c7d68","488":"195cdcce","893":"79d4df9f","918":"195cdcce"}[chunkId] + ".css";
};